import PubSub from 'pubsub-js';

const PUBSUB_TOPICS = Object.freeze({
  MENU_CLICKED: 'MENU_CLICKED',
  PLUS_BTN_CLICKED: 'MAP_MODAL_OPEN',
  SHOW_CONTENT: 'SHOW_CONTENT',
  GO_HOME: 'GO_HOME',
  GO_TO_ADMIN: 'GO_TO_ADMIN',
  ADMIN_MODULE_SELECTED: 'ADMIN_MODULE_SELECTED',
  REFRESH_LEFT_PANEL: 'REFRESH_LEFT_PANEL',
  LANGUAGE_CHANGED: 'LANGUAGE_CHANGED',
  REFRESH_IFRAME: 'LANGUAGE_CHANGED_IFRAME',
});

const subscribe = PubSub.subscribe;
const unsubscribe = PubSub.unsubscribe;
const publish = PubSub.publish;
const getSubscriptions = PubSub.getSubscriptions;

export { PUBSUB_TOPICS, publish, subscribe, unsubscribe, getSubscriptions };
